import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import FormPage from "./pages/FormPage";
import RawFruitPage from "./pages/RawFruit";
import MachinePage from "./pages/Machine";
import GenerateQrCode from "./pages/GenerateQrCode";
import FarmerPage from "./pages/Farmer";
import Header from "./Header"; // <-- Imported from our new Header component
import "./App.css"; // <-- Updated CSS

// A simple protected route to ensure user is authenticated
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

// Footer can remain the same or in its own file if desired
const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <p>&copy; {new Date().getFullYear()} Fruit Management System</p>
      <p>
        Made with <span className="heart">❤</span> for farmers
      </p>
    </footer>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/scan/:qrId" element={<FormPage />} />
            <Route
              path="/raw-fruit"
              element={
                <ProtectedRoute>
                  <RawFruitPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/machines"
              element={
                <ProtectedRoute>
                  <MachinePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/farmers"
              element={
                <ProtectedRoute>
                  <FarmerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qr-code"
              element={
                <ProtectedRoute>
                  <GenerateQrCode />
                </ProtectedRoute>
              }
            />
            {/* Fallback route */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
